import {isRtl} from 'scratch-l10n';
import editorMessages from 'scratch-l10n/locales/editor-msgs';

const localGuiMessages = {
    en: {
        'gui.sharedMessages.backdrop': 'backdrop{index}',
        'gui.sharedMessages.costume': 'costume{index}',
        'gui.sharedMessages.sprite': 'Sprite{index}',
        'gui.sharedMessages.pop': 'pop',
        'gui.sharedMessages.replaceProjectWarning': 'Replace contents of the current project?',
        'gui.sharedMessages.loadFromComputerTitle': 'Load from your computer',
        'gui.stageHeader.saveThumbnailMessage': 'Are you sure you want to set your thumbnail?',
        'gui.stageHeader.thumbnailTooltipTitle': 'Hey there! 👋',
        'gui.gui.defaultProjectTitle3D': '3D作品'
    },
    'zh-cn': {
        'gui.sharedMessages.backdrop': '背景{index}',
        'gui.sharedMessages.costume': '造型{index}',
        'gui.sharedMessages.sprite': '角色{index}',
        'gui.sharedMessages.pop': '啵',
        'gui.sharedMessages.replaceProjectWarning': '是否替换当前作品内容？',
        'gui.sharedMessages.loadFromComputerTitle': '从本地打开',
        'gui.stageHeader.saveThumbnailMessage': '确定要设置当前缩略图吗？',
        'gui.stageHeader.thumbnailTooltipTitle': '设置作品缩略图',
        'gui.gui.defaultProjectTitle3D': '3D作品'
    }
};

const editorMessagesWithLocalGuiMessages = Object.keys(editorMessages).reduce((messages, locale) => ({
    ...messages,
    [locale]: {
        ...editorMessages[locale],
        ...(localGuiMessages[locale] || localGuiMessages.en)
    }
}), {});

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale: editorMessagesWithLocalGuiMessages,
    messages: editorMessagesWithLocalGuiMessages.en
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        return Object.assign({}, state, {
            isRtl: isRtl(action.locale),
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: state.messagesByLocale[action.locale]
        });
    case UPDATE_LOCALES:
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: action.messagesByLocale,
            messages: action.messagesByLocale[state.locale]
        });
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (Object.prototype.hasOwnProperty.call(currentState.messagesByLocale, locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
